import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { withApollo } from 'react-apollo';
import RootHeader from '../Header/Index';
import { withReloadable, withFirebase } from '../../../hoc';
import SiderContent from '../../sections/Layouts/SidebarContent';
import { device } from '../../../utils/breakpoints';
import {
    Icon,
    Loading,
    Main,
    InnerAsideContent,
    RootContainer,
    Aside,
    Header,
    FixedContainer,
    Logo
} from '../../common';
import { withRouter } from 'react-router';
import UserSession from '../../auth/UserSession';
import { LoadingScreen } from '../Loading';
import AuditDateRange from '../../contexts/AuditDateRange';
import OrderEventsProvider from '../../firebase/OrderEvents';
import PubSub from '../../../services/PubSub';
import InvoicingDateRange from '../../contexts/InvoicingDateRange';

const CloseSiderButton = ({ toggleSidebar, closed }) => {
    const AsideFooter = styled.div`
    margin-left: auto;
    height: 40px;
  `;

    const CloseButton = styled.div`
    width: 30px;
    height: 30px;
    border-radius: 15px;
    justify-content: center;
    background-color: #1fa02e;
    align-items: center;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);
    display: none;
    cursor: pointer;
    @media ${device.tablet} {
      display: flex;
    }
  `;
    return (
        <AsideFooter>
            <CloseButton onClick={() => toggleSidebar(!closed)}>
                <Icon
                    name={closed ? 'arrow-right' : 'arrow-left'}
                    right={closed ? '0' : '2'}
                    left={closed ? '2' : '0'}
                    size='12'
                    color='#ffff'
                />
            </CloseButton>
        </AsideFooter>
    );
};

const SidebarToggler = styled.div`
  top: 65px;
  position: absolute;
  left: ${props => props.opened ? 'var(--btn-sidebar-opened-width)' : 'var(--btn-sidebar-closed-width)'};
  z-index: 100;
`;

class Layout extends PureComponent {
    state = { closed: true, CenterHeaderComponent: () => '', RightHeaderComponent: () => '' }

    toggleSidebar = () => this.setState(({ closed }) => ({ closed: !closed }), () => window.localStorage.setItem('closed', this.state.closed))

    componentDidMount () {
        this.setState({ closed: window !== 'undefined' && window.localStorage.getItem('closed') !== 'false' });

        PubSub.register('SET_CENTER_HEADER', (msg, data) => {
            this.setState({
                CenterHeaderComponent: data
            });
        });

        PubSub.register('SET_RIGHT_HEADER', (msg, data) => {
            this.setState({
                RightHeaderComponent: data
            });
        });
    }

    render () {
        const { children, withFooter, withSidebar, client, session, history, ...props } = this.props;
        const { closed } = this.state;

        if (!withSidebar) return children;

        props.CenterHeaderComponent = this.state.CenterHeaderComponent;
        props.RightHeaderComponent = this.state.RightHeaderComponent;

        return (
            <OrderEventsProvider>
                <AuditDateRange>
                    <InvoicingDateRange>
                        <UserSession typeCache>
                            {({ loading }) => (
                                <Loading loading={loading} Component={LoadingScreen}>
                                    <RootContainer>
                                        <SidebarToggler opened={!closed}>
                                            <FixedContainer>
                                                <CloseSiderButton closed={closed} toggleSidebar={this.toggleSidebar} />
                                            </FixedContainer>
                                        </SidebarToggler>
                                        <Aside closed={closed}>
                                            <Header>
                                                <Logo small={closed} />
                                            </Header>
                                            <InnerAsideContent overflowY={!closed && 'auto'}>
                                                <SiderContent collapsed={closed} />
                                            </InnerAsideContent>
                                        </Aside>
                                        <Main withFooter={withFooter}>
                                            <Header sticky>
                                                <RootHeader {...props} />
                                            </Header>
                                            <>
                                                {children}
                                            </>
                                        </Main>
                                    </RootContainer>
                                </Loading>
                            )}
                        </UserSession>
                    </InvoicingDateRange>
                </AuditDateRange>
            </OrderEventsProvider>
        );
    }
}

Layout.defaultProps = {
    withFooter: false,
    withSidebar: false
};

export default withFirebase(withApollo(withReloadable(withRouter(Layout), ['ts'])));
